import {useEffect} from 'react';
import {useGetPendingApprovalsCount} from '../api/admin/useGetPendingApprovalsCount.ts';

interface PendingApprovalsUpdaterProps {
    isAuthenticated: boolean;
    isAdmin: boolean;
    onUpdate: (pendingCount: number) => void;
}

export function PendingApprovalsUpdater({
    isAuthenticated,
    isAdmin,
    onUpdate
}: PendingApprovalsUpdaterProps) {
    const {data: pendingCount} = useGetPendingApprovalsCount(
        isAuthenticated,
        isAdmin
    );

    useEffect(() => {
        onUpdate(pendingCount || 0);
    }, [pendingCount, onUpdate]);

    return null;
}
